<template>
  <data-form :entity="filters" :fields="fields" @change="filtersChanged" :hideButtons="true" />
</template>

<script>
export default {
  name: 'event-table-config',
  props: {
    filters: {
      type: Object,
      default: () => ({
        mobileId: null,
        eventTypeId: null,
        dateFrom: null,
        dateTo: null,
        size: 100
      })
    },
    hideEventTypeId: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    fields () {
      return {
        mobileId: {
          type: 'select',
          options: this.filterOptions('mobiles')(''),
          filter: this.filterOptions('mobiles'),
          placeholder: true
        },
        eventTypeId: {
          type: 'select',
          options: this.filterOptions('event-types', model => ({ label: 'eventType.' + model.name, value: model.id }))(''),
          filter: this.filterOptions('event-types', model => ({ label: 'eventType.' + model.name, value: model.id })),
          placeholder: true,
          hidden: this.hideEventTypeId
        },
        dateFrom: {
          type: 'datetime'
        },
        dateTo: {
          type: 'datetime'
        },
        size: {
          type: 'number',
          max: 10000,
          rules: [{type: 'number', max: 10000}]
        }
      }
    }
  },
  methods: {
    filtersChanged (filters) {
      this.$emit('filtersChanged', filters)
      this.$emit('propertiesChanged', { filters })
    },
    filterOptions (model, map = (model => ({ label: model.contact_name, value: model.id }))) {
      return (query) => {
        const models = this.$store.getters[`${model}/data`](this.$store.dispatch)

        let result = models.map(map)

        result = result.filter(option => option.label.toLowerCase().includes((query || '').toLowerCase()))

        result = result.reverse()

        return result.slice(0, 10)
      }
    }
  },
  beforeMount () {
    this.filtersChanged(this.filters)
  }
}
</script>



// WEBPACK FOOTER //
// EventTableConfig.vue?60cfd736